import React from 'react';
import PublicLayout from '../components/Public/PublicLayout';
import RevealBlock from '../components/Public/RevealBlock';
import heroImage from '../assets/public/sections/about_values_clean.jpg';
import qualityImage from '../assets/public/sections/about_quality_clean.jpg';
import valuesImage from '../assets/public/sections/about_values_clean.jpg';
import historyImageOne from '../assets/public/sections/about_hist_1_clean.jpg';
import historyImageTwo from '../assets/public/sections/about_hist_2_clean.jpg';
import historyImageThree from '../assets/public/sections/about_hist_3_clean.jpg';
import '../styles/PublicSite.css';

const historyGallery = [
  historyImageOne,
  historyImageTwo,
  historyImageThree,
  historyImageOne,
  historyImageTwo,
  historyImageThree,
];

const milestones = [
  { year: '2006', description: 'Inicio de operaciones con enfoque en calidad industrial.' },
  { year: '2014', description: 'Expansion de capacidad para atender exportaciones regionales.' },
  { year: '2026', description: 'Operacion con certificaciones, control de calidad y mejora continua.' },
];

const SobreNosotros = () => {
  return (
    <PublicLayout>
      <div className="about-page">
        <section className="about-hero">
          <img src={heroImage} alt="Equipo de Maderas del Atlantico" />
          <div className="about-hero-overlay" />

          <div className="about-hero-cards">
            <article>
              <h2>Nuestra mision</h2>
              <p>
                Proveer palets de madera confiables y certificados para procesos logistico, industriales y
                sostenibles.
              </p>
            </article>

            <article>
              <h2>Nuestra vision</h2>
              <p>
                Ser una empresa referente en fabricacion de palets de madera en Guatemala y Centroamerica,
                reconocida por su calidad, cumplimiento normativo y seguridad operativa.
              </p>
            </article>
          </div>
        </section>

        <RevealBlock className="about-milestones" delay={70}>
          {milestones.map((milestone) => (
            <article key={milestone.year}>
              <span className="milestone-year">{milestone.year}</span>
              <p>{milestone.description}</p>
            </article>
          ))}
        </RevealBlock>

        <RevealBlock className="about-section about-quality" delay={100}>
          <figure>
            <img src={qualityImage} alt="Proceso de secado de palets" />
          </figure>

          <article>
            <h2>Compromiso con la calidad</h2>
            <p>
              La calidad es el eje central de nuestros procesos. Contamos con operaciones certificadas para
              tratamiento termico NIMF-15 (HT), garantizando que nuestros palets cumplan con los estandares
              internacionales requeridos para exportacion.
            </p>
          </article>
        </RevealBlock>

        <section className="about-values-band">
          <h2>Nuestros valores</h2>

          <RevealBlock className="about-values-content" delay={130}>
            <figure>
              <img src={valuesImage} alt="Equipo de trabajo en planta" />
            </figure>

            <article>
              <p>
                Nos guiamos por valores de responsabilidad, calidad, transparencia y compromiso, que se
                reflejan en cada etapa de nuestro proceso. Fomentamos un entorno de trabajo seguro y de
                crecimiento humano para fortalecer capacidades operativas y programas de capacitacion
                continua.
              </p>
            </article>
          </RevealBlock>
        </section>

        <RevealBlock className="about-section about-history" delay={160}>
          <h2>Nuestra historia</h2>
          <div className="about-history-grid">
            {historyGallery.map((image, index) => (
              <figure key={`${image}-${index}`}>
                <img src={image} alt={`Momento historico ${index + 1}`} />
              </figure>
            ))}
          </div>
        </RevealBlock>
      </div>
    </PublicLayout>
  );
};

export default SobreNosotros;
